module.exports = __webpack_public_path__ + "9693e2360fab41e9b54c492a2465994c.svg";